import React from 'react';
import { connect } from 'react-redux';
import { Helmet as Meta } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

const MetaController = withRouter((props) => {
  const metaTags = [];
  if (props.meta) {
    metaTags.push(props.meta.title ? (<title key={'title'}>{props.meta.title}</title>) : null);
    metaTags.push(props.meta.description ? (<meta key={'description'} name="description" content={props.meta.description} />) : null);
    metaTags.push(props.meta.robots ? (<meta key={'robots'} name="robots" content={props.meta.robots} />) : null);
    metaTags.push(<meta key={'url'} property="og:url" content={props.location.pathname} />);
    if (props.meta.social) {
      metaTags.push(props.meta.social.site_name ? (<meta key={'sitename'} property="og:site_name" content={props.meta.social.site_name} />) : null);
      metaTags.push(props.meta.social.publisher ? (<meta key={'publisher'} property="article:publisher" content={props.meta.social.publisher} />) : null);
      metaTags.push(props.meta.social.tags ? (props.meta.social.tags.map(tag => <meta key={tag} property="article:tag" content={tag} />)) : null);
      metaTags.push(props.meta.social.sections ? (props.meta.social.sections.map(section => <meta key={section} property="article:section" content={section} />)) : null);
      metaTags.push(props.meta.social.published_time ? (<meta key={'published_time'} property="article:published_time" content={props.meta.social.published_time} />) : null);
      metaTags.push(props.meta.social.image ? (<meta key={'ogimage'} property="og:image" content={props.meta.social.image} />) : null);
      metaTags.push(props.meta.social.image ? (<meta key={'twitter:card'} property="twitter:card" content={props.meta.social.image} />) : null);
      metaTags.push(props.meta.social.image ? (<meta key={'twitter:image:src'} property="twitter:image:src" content={props.meta.social.image} />) : null);
      metaTags.push(props.meta.social.twitter ? (<meta key={'twitter:site'} property="twitter:site" content={props.meta.social.twitter} />) : null);
    }
  }

  return (
    <Meta>
      {metaTags}
    </Meta>
  );
});

MetaController.propTypes = {
  meta: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    robots: PropTypes.string,
    url: PropTypes.string,
    site_name: PropTypes.string,
    publisher: PropTypes.string,
    published_time: PropTypes.string,
    image: PropTypes.string,
    twitter: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    sections: PropTypes.arrayOf(PropTypes.string),
  }),
};

MetaController.defaultProps = {
  meta: {
    title: '',
    description: '',
    robots: '',
    url: '',
    site_name: '',
    publisher: '',
    published_time: '',
    image: '',
    twitter: '',
    tags: [],
    sections: [],
  },
};

function mapStateToProps(state) {
  return {
    meta: state.globalsState.meta,
    lang: state.globalsState.lang,
  };
}

export default connect(mapStateToProps)(MetaController);



// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Meta/MetaController.jsx